/**********************************************************
Chemical Application Form
**********************************************************/
import { TextInput, NumberInput, Select, DatePicker, TimePicker, AutoComplete,
  RadioButton } from '../inputs';
import SolutionsTable from './chem_app_solution_table';
import { UNITS_OF_MEASURE } from '../../cult_constants';
import { packageForm, mapEmployeeForAutoComplete, mapPropForAutoComplete,
  parseDosage, setDosage, onDummyComplete } from '../../cult_utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  cert: PropTypes.object,
  chemicalList: PropTypes.array,
  eid: PropTypes.string,
  employees: PropTypes.array,
  fields: PropTypes.array,
  isEditing: PropTypes.bool,
  solutions: PropTypes.array,
  totalGallons: PropTypes.number,
  addSolution: PropTypes.func,
  editSolution: PropTypes.func,
  deleteSolution: PropTypes.func,
  fetchFields: PropTypes.func,
  selectSolutionToEdit: PropTypes.func,
  setTotalGallons: PropTypes.func
};

class ChemicalApplicationForm extends Component {
  render() {
    return (
      <div>
        <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m4 l3 xl3">
              <DatePicker id={'chemApp-date'} label={'Date'} min={'2019-01-01'} max={moment().format('YYYY-MM-DD')} required={true} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <label>Location</label>
              <div className="radio-flex">
                <RadioButton id={'chemApp-kau'} name={'chemApp-loc'} value={'71'} label={'Kau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                <RadioButton id={'chemApp-keaau'} name={'chemApp-loc'} value={'72'} label={'Keaau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
              </div>
            </div>
            <div className="col s12 m4 l3 xl3">
              <AutoComplete id={'chemApp-fieldId'} label={'Field'} data={mapPropForAutoComplete(this.props.fields, 'field')}
                onComplete={(val, id) => this.props.selectField(this.props.fields, val, id, this.props.editChem)}
                onBlur={(e) => this.props.selectField(this.props.fields, e.target.value, e.target.id, this.props.editChem)}
              />
            </div>
            <div className="col s12 m4 l3 xl3">
              <AutoComplete id={'chemApp-employee'} label={'Employee'} data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 l3 xl3">
              <TimePicker id={'chemApp-startTime'} label={'Start Time'} required={true} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <TimePicker id={'chemApp-endTime'} label={'End Time'} required={true} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <NumberInput id={'chemApp-acresCompleted'} label={'Acres Completed'} min={'0.00'} max={'275'} step={'0.01'} defaultValue={0.00} required={true} />
            </div>
            <div className="col s12 m4 l3 xl3">
              <NumberInput id={'chemApp-round'} label={'Round'} min={'1'} max={'10'} step={'1.0'} defaultValue={1} required={true} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <label>Status</label>
              <div className="radio-flex">
                <RadioButton id={'chemApp-isCompleteYes'} name={'chemApp-isComplete'} label={'Complete'} value={'Complete'} />
                <RadioButton id={'chemApp-isCompleteNo'} name={'chemApp-isComplete'} label={'Incomplete'} value={'Incomplete'} />
              </div>
            </div>
            <div className="col s12 m6 l6 xl6">
              <label>Method</label>
              <div className="radio-flex">
                <RadioButton id={'chemApp-methodAirblast'} name={'chemApp-method'} label={'Airblast'} value={'Airblast'} />
                <RadioButton id={'chemApp-methodBroadcast'} name={'chemApp-method'} label={'Broadcast'} value={'Broadcast'} />
                <RadioButton id={'chemApp-methodSpot'} name={'chemApp-method'} label={'Spot'} value={'Spot'} />
              </div>
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'chemUsed-measurement'} label={'Gallons Used'} max={'50000'} step={'0.01'} defaultValue={0.00} onBlur={(e) => this.props.setTotalGallons(e.target.value)} />
            </div>
            <div className="col s12 m8 l8 xl8">
              <TextInput id={'chemApp-notes'} label={'Notes'} defaultValue={'N/A'} />
            </div>
          </div>
        </form><hr />
        <form id={'chemicals-used-form'} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m4 l3 xl3">
              <Select id={'chemUsed-chemId'} label={'Chemical'}
                onChange={(e) => setDosage({
                  dosage: parseDosage(this.props.chemicalList.find((c) => c.id === Number(e.target.value))),
                  quantId: 'chemUsed-chemDosage1',
                  unitId: 'chemUsed-chemDosage2'
                })}
                opts={this.props.chemicalList.map((c) => { return { label: c.name, val: c.id}; } )}  />
            </div>
            <div className="col s6 m3 l3 xl3">
              <NumberInput id={'chemUsed-chemDosage1'} label={'Quantity'} min={"0"} max={"5000"} step={"0.1"} />
            </div>
            <div className="col s6 m3 l3 xl3">
              <Select id={'chemUsed-chemDosage2'} label={'Unit'} opts={UNITS_OF_MEASURE.filter((c) => c.type === 'volume' || c.type === 'mass')} />
            </div>
            <div className="col s12 m3 l3 xl3">
            {
              this.props.isEditing ?
                <center>
                  <button className="btn btn-large blue chem-add"
                    onClick={() => this.props.editSolution({
                      solution: packageForm('chemicals-used-form'),
                      editSolution: this.props._editSolution,
                      totalGallons: this.props.totalGallons,
                      formId: 'chemicals-used-form',
                      chemicals: this.props.chemicalList
                    })}>
                    Edit Solution
                  </button>
                </center>
              : <center>
                  <button className="btn btn-large chem-add"
                    onClick={() => this.props.addSolution({
                      solution: packageForm('chemicals-used-form'),
                      totalGallons: this.props.totalGallons,
                      formId: 'chemicals-used-form',
                      chemicals: this.props.chemicalList
                    })}>
                    Add Solution
                  </button>
                </center>
            }
            </div>
          </div>
        </form>
        { this.props.solutions.length > 0 ?
          <div className="row">
            <div className="col s12">
              <SolutionsTable solutions={this.props.solutions} chemicalList={this.props.chemicalList} formId={'chemicals-used-form'}
              edit={this.props.selectSolutionToEdit} _delete={this.props.deleteSolution} readOnly={false} editChem={false} />
            </div>
          </div>
          : ''
        }
      </div>
    );
  }
}

ChemicalApplicationForm.propTypes = propTypes;
export default ChemicalApplicationForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_form.js